import React from 'react';

const sizeMap = {
  sm: 20,
  md: 32,
  lg: 48,
  xl: 64,
};

export default function LoadingSpinner({ size = 'md', color = 'var(--color-primary)', style }) {
  const dim = sizeMap[size] || sizeMap.md;
  const strokeWidth = dim < 30 ? 3 : 4;

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      <svg
        width={dim}
        height={dim}
        viewBox="0 0 50 50"
        style={{ animation: 'spin 0.8s linear infinite' }}
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="rgba(212, 175, 55, 0.15)"
          strokeWidth={strokeWidth}
        />
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray="80, 200"
          strokeDashoffset="0"
        />
      </svg>
    </div>
  );
}
